export default __webpack_public_path__ + "static/media/psg-prize-mobile.8e93821d.png";